import { Grid, Paper } from "@mui/material";
import React from "react";
import MainMenu from "../../components/MainMenu";
import SponsorList from "../../components/SponsorManagementComponents/SponsorList";
import SponsorListData from "../../components/SponsorManagementComponents/SponsorListData";

const index = () => {
  return (
    <MainMenu>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3}>
            {/* <SponsorList /> */}
            <SponsorListData />
          </Paper>
        </Grid>
      </Grid>
    </MainMenu>
  );
};

export default index;
